export class HistoricoSolicitacao {
  analyticals: Array<Historico>;
  consent: Array<Historico>;
}

export class Historico {
  orderId: string;
  createDate: string;
  origin: string;
  protocol: string;
  status: string;
}